export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 border border-white/30 rounded-full">
              <span className="text-xs uppercase tracking-widest text-white/90">iOS EXPERTS</span>
            </div>
            
            <div className="space-y-4">
              <h2 className="text-7xl font-bold text-white leading-tight">
                Modern Applications
              </h2>
              <p className="text-6xl font-light italic text-teal-400">
                for Enhanced
              </p>
              <h2 className="text-7xl font-bold text-white leading-tight">
                Mobile Experience
              </h2>
            </div>

            <p className="text-lg text-gray-300 leading-relaxed max-w-xl">
              We develop cutting-edge iOS applications that enhance user experience and improve the security of mobile devices across the Apple ecosystem.
            </p>
          </div>

          {/* Right side - iPhone Mockup */}
          <div className="relative flex justify-center items-center">
            <div className="relative transform rotate-6 hover:rotate-0 transition-transform duration-500">
              <div className="w-80 h-[600px] bg-gradient-to-br from-slate-800 to-slate-900 rounded-[3rem] shadow-2xl p-3 border-8 border-slate-700">
                <div className="w-full h-full bg-gradient-to-br from-teal-500 to-blue-600 rounded-[2.5rem] overflow-hidden relative">
                  {/* App Interface Mockup */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-8">
                    <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-3xl flex items-center justify-center mb-6">
                      <i className="ri-shield-check-line text-5xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">VPN Secure</h3>
                    <p className="text-sm text-white/80 text-center">Protected Connection</p>
                    <div className="mt-8 w-full space-y-3">
                      <div className="h-12 bg-white/10 backdrop-blur-sm rounded-xl"></div>
                      <div className="h-12 bg-white/10 backdrop-blur-sm rounded-xl"></div>
                      <div className="h-12 bg-white/10 backdrop-blur-sm rounded-xl"></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Shadow effect */}
              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 w-64 h-8 bg-black/30 blur-2xl rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}